import { AlertTriangleIcon, CheckIcon } from "../../icons";

export interface ToastInterface {
  id: string; // date is assigned in the action so undefined at first
  kind: "ERROR" | "SUCCESS";
  message: string;
  autoDismissDisabled?: boolean;
}

type ToastProps = {
  toast: ToastInterface;
  dismissHandler: (id: ToastInterface["id"]) => void;
};
const Toast = ({ toast, dismissHandler }: ToastProps) => {
  return (
    <div className="flex items-end justify-center px-4 py-2 pointer-events-none p-2 items-start justify-end">
      <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black/5 overflow-hidden">
        <div className="p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              {toast.kind === "ERROR" ? (
                <AlertTriangleIcon className="h-6 w-6 text-red-400" />
              ) : (
                <CheckIcon className="h-6 w-6 text-emerald-400" />
              )}
            </div>
            <div className="ml-3 w-0 flex-1 pt-0.5">
              <p className="text-sm font-medium text-gray-900">{toast.kind === "ERROR" ? "Error" : "Success"}</p>
              <p className="mt-1 text-sm text-gray-500">{toast?.message}</p>
            </div>
            <div className="ml-4 flex-shrink-0 flex">
              <button
                onClick={() => dismissHandler(toast.id)}
                className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                <span className="sr-only">Close</span>
                <svg
                  className="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toast;
